import type { identifier } from '@core/models/base';

export enum PackageAddonTypes {
  /**
   * NOT an addon package, only used to update a package that might have been added as an addon and switched to standard
   */
  STANDARD = 'standard',
  /**
   * Addon package requires a standard package to be added
   */
  ADDON_STANDARD = 'addon_standard',
  /**
   * Addon package requires a minimum price to be added
   */
  ADDON_PRICE = 'addon_price',
}
export interface PackageAddonDisplayModel {
  id: number;
  requiredMinPrice?: number;
  requiresStandard?: boolean;
  type: `${PackageAddonTypes}`;
}

export interface PackageAddonUpdateModel {
  id: number;
  requiredMinPrice?: number;
  requiresStandard?: boolean;
  type: `${PackageAddonTypes}`;
}

export interface PackageAddonCreateModel {
  requiredMinPrice?: number;
  requiresStandard?: boolean;
  type: `${PackageAddonTypes}`;
}

export interface PackageAddonUpsertModel extends PackageAddonCreateModel {
  id?: identifier;
  packageId?: identifier;
}

export const standardPackageAddon = {
  id: undefined,
  packageId: undefined,
  requiredMinPrice: 0,
  requiresStandard: undefined,
  type: PackageAddonTypes.STANDARD,
} satisfies PackageAddonUpsertModel;

export const addonStandardPackageAddon = {
  id: undefined,
  packageId: undefined,
  requiredMinPrice: 0.00,
  requiresStandard: true,
  type: PackageAddonTypes.ADDON_STANDARD,
} satisfies PackageAddonUpsertModel;
